/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AuditResponse,
  ClientRequest,
  ClientResponse,
  ClientsRequest,
  ExternalOrgCommercialTermsRequest,
  ExternalOrgCommercialTermsResponse,
  PageResponseClientListItemResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Clients<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags client-controller
   * @name ShowClient
   * @request GET:/clients/{clientId}
   * @secure
   * @response `200` `ClientResponse` OK
   */
  showClient = (clientId: string, params: RequestParams = {}) =>
    this.request<ClientResponse, any>({
      path: `/clients/${clientId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags client-controller
   * @name UpdateClient
   * @request PUT:/clients/{clientId}
   * @secure
   * @response `200` `ClientResponse` OK
   */
  updateClient = (
    clientId: string,
    data: ClientRequest,
    params: RequestParams = {},
  ) =>
    this.request<ClientResponse, any>({
      path: `/clients/${clientId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags client-controller
   * @name DeleteClient
   * @request DELETE:/clients/{clientId}
   * @secure
   * @response `200` `ClientResponse` OK
   */
  deleteClient = (clientId: string, params: RequestParams = {}) =>
    this.request<ClientResponse, any>({
      path: `/clients/${clientId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags client-controller
   * @name UpdateClient1
   * @request PATCH:/clients/{clientId}
   * @secure
   * @response `200` `ClientResponse` OK
   */
  updateClient1 = (
    clientId: string,
    data: ClientRequest,
    params: RequestParams = {},
  ) =>
    this.request<ClientResponse, any>({
      path: `/clients/${clientId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-org-commercial-terms-controller
   * @name GetExternalOrgCommercialTerms
   * @summary Get commercial terms for an advertiser organization
   * @request GET:/clients/externalClients/{advertiserOrganizationId}/commercialTerms
   * @secure
   * @response `200` `ExternalOrgCommercialTermsResponse` OK
   */
  getExternalOrgCommercialTerms = (
    advertiserOrganizationId: string,
    params: RequestParams = {},
  ) =>
    this.request<ExternalOrgCommercialTermsResponse, any>({
      path: `/clients/externalClients/${advertiserOrganizationId}/commercialTerms`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-org-commercial-terms-controller
   * @name SetExternalOrgCommercialTerms
   * @summary Set commercial terms for an advertiser organization
   * @request PUT:/clients/externalClients/{advertiserOrganizationId}/commercialTerms
   * @secure
   * @response `200` `ExternalOrgCommercialTermsResponse` OK
   */
  setExternalOrgCommercialTerms = (
    advertiserOrganizationId: string,
    data: ExternalOrgCommercialTermsRequest,
    params: RequestParams = {},
  ) =>
    this.request<ExternalOrgCommercialTermsResponse, any>({
      path: `/clients/externalClients/${advertiserOrganizationId}/commercialTerms`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags client-controller
   * @name AddClient
   * @request POST:/clients
   * @secure
   * @response `200` `ClientResponse` OK
   */
  addClient = (data: ClientRequest, params: RequestParams = {}) =>
    this.request<ClientResponse, any>({
      path: `/clients`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags client-controller
   * @name GetClients
   * @summary Get Clients
   * @request POST:/clients/getClients
   * @secure
   * @response `200` `PageResponseClientListItemResponse` OK
   */
  getClients = (
    data: ClientsRequest,
    query?: {
      search?: string;
      hasTenancy?: boolean;
      source?: "INTERNAL" | "EXTERNAL";
      groupBy?: "ORGANIZATION";
    },
    params: RequestParams = {},
  ) =>
    this.request<PageResponseClientListItemResponse, any>({
      path: `/clients/getClients`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags client-controller
   * @name History
   * @request GET:/clients/history/{clientId}
   * @secure
   * @response `200` `(AuditResponse)[]` OK
   */
  history = (clientId: string, params: RequestParams = {}) =>
    this.request<AuditResponse[], any>({
      path: `/clients/history/${clientId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags client-controller
   * @name ListBrands
   * @request GET:/clients/brands
   * @secure
   * @response `200` `Record<string,(string)[]>` OK
   */
  listBrands = (params: RequestParams = {}) =>
    this.request<Record<string, string[]>, any>({
      path: `/clients/brands`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags client-controller
   * @name TerminateTenancy
   * @request DELETE:/clients/{clientId}/tenancy
   * @secure
   * @response `200` `ClientResponse` OK
   */
  terminateTenancy = (clientId: string, params: RequestParams = {}) =>
    this.request<ClientResponse, any>({
      path: `/clients/${clientId}/tenancy`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}
